export default __webpack_public_path__ + "static/media/single-project-page-03-img13.e21f01d9.jpg";